exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".post-webwidget-v2-now-playing-detail-wrapper[_v-26dc26e0]{margin:1em}.post-webwidget-v2-now-playing-detail-wrapper .post-webwidget-v2-now-playing-detail-show-name[_v-26dc26e0]{margin-bottom:.5em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.post-webwidget-v2-now-playing-detail-wrapper .post-webwidget-v2-now-playing-detail-episode-name[_v-26dc26e0]{font-size:1.2em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.post-webwidget-v2-now-playing-detail-wrapper .post-webwidget-v2-now-playing-detail-share-buttons[_v-26dc26e0]{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:justify;justify-content:space-between;margin:1em 0 0;height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-26dc26e0&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v2-components/NowPlayingDetail.vue
// module id = 277
// module chunks = 0